export default __webpack_public_path__ + "static/media/quicken.419ab3c3.png";